<template>
  <div class="search">
    <el-card style="margin-bottom:12px">
      <div class="flex">
        <div class="cTitle">筛选查询</div>
        <div class="btnAction">
          <el-input v-model="searchForm.username" placeholder="请输入登录账号" style="width:160px;margin-right:8px" clearable></el-input>
          <el-input v-model="searchForm.realName" placeholder="请输入真实姓名" style="width:160px;margin-right:8px" clearable></el-input>
          <el-button type="primary" plain @click="getDataList" size="mini">搜索</el-button>
        </div>
      </div>
    </el-card>

    <el-card>
      <div class="flex">
        <div class="cTitle">小程序系统用户管理</div>
        <div class="btnAction">
          <el-button type="primary" plain round @click="add" size="mini">添加用户</el-button>
        </div>
      </div>
      <div style="margin-top:16px">
        <vxe-table
          align="center"
          ref="table"
          stripe
          size="medium"
          :height="height - 200"
          :loading="loading"
          :data="data"
        >
          <vxe-column type="seq" width="60" title="#"></vxe-column>
          <vxe-column field="username" title="登录账号"></vxe-column>
          <vxe-column field="realName" title="真实姓名"></vxe-column>
          <vxe-column field="mobile" title="手机号码"></vxe-column>
          <vxe-column field="openId" title="微信绑定">
            <template #default="{ row }">
               <el-button size="mini" v-if="!row.openId" style="color: red;" @click="bindWeiXin(row)" type="text">点击绑定</el-button>
               <el-button size="mini" v-else @click="bindWeiXin(row)" type="text">已绑定</el-button>
            </template>
          </vxe-column>
          <vxe-column field="status" title="状态">
            <template #default="{ row }">
              <el-switch
                v-model="row.status"
                :active-value="1"
                :inactive-value="0"
                @change="handleStatusChange(row)"
              ></el-switch>
            </template>
          </vxe-column>
          <vxe-column field="createTime" title="创建时间" width="160"></vxe-column>
          <vxe-column title="操作" width="320" fixed="right">
            <template #default="{ row }">
              <el-button size="mini" type="text" @click="edit(row)">编辑</el-button>
              <el-button size="mini" type="text" style="color:#67C23A" @click="openPermission(row)">权限配置</el-button>
              <el-button size="mini" type="text" @click="handleResetPass(row)">重置密码</el-button>
              <el-button size="mini" type="text" style="color: #f56c6c" @click="remove(row)">删除</el-button>
            </template>
          </vxe-column>
        </vxe-table>
        <Row type="flex" justify="end" class="page">
          <Page
            :current="page.currentPage"
            :total="page.total"
            :page-size="page.pageSize"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            :page-size-opts="[10, 20, 50]"
            size="small"
            show-total
            show-elevator
            show-sizer
          ></Page>
        </Row>
      </div>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="modalTitle" :visible.sync="modalVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="formValidate" label-width="100px">
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入登录账号" :disabled="!!form.id"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" v-if="!form.id">
          <el-input v-model="form.password" placeholder="请输入登录密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="modalVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 微信扫码绑定弹窗 -->
    <el-dialog title="微信扫码绑定(如若已绑定请刷新列表后查看)" :visible.sync="modalVisibleWeiXin" width="500px">
      <div class="qr" style="text-align: center;">
        <div style="padding: 2px;">绑定人信息：{{ selectItem.realName }}({{ selectItem.username }})</div>
        <div style="padding: 2px;">
          是否绑定：
          <span style="color:green" v-if="selectItem.openId">已绑定</span>
          <span v-else style="color: red;">待绑定</span>
        </div>
        <vue-qrcode :value="qrcodeText" :options="{ width: 230 }"></vue-qrcode>
      </div>
      <div slot="footer"></div>
    </el-dialog>

    <!-- 权限配置弹窗 -->
    <el-dialog title="权限配置" :visible.sync="permissionVisible" width="700px" :close-on-click-modal="false">
      <div style="margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #eee">
        <span style="font-weight:bold;margin-right:8px">用户：</span>
        <span style="color:#409EFF">{{ selectItem.realName }}（{{ selectItem.username }}）</span>
      </div>
      
      <!-- 菜单权限 -->
      <div class="permission-section">
        <div class="section-header">
          <span class="section-title">菜单权限</span>
          <span class="section-desc">勾选用户可以访问的功能</span>
        </div>
        <el-checkbox-group v-model="selectedMenus" class="menu-checkbox-group">
          <el-checkbox label="gbList">过磅信息</el-checkbox>
          <el-checkbox label="abnormalList">异常过磅</el-checkbox>
          <el-checkbox label="deviceControl">设备控制</el-checkbox>
          <el-checkbox label="statistics">统计汇总</el-checkbox>
        </el-checkbox-group>
      </div>
      
      <!-- 设备权限 -->
      <div class="permission-section" style="margin-top:20px">
        <div class="section-header">
          <span class="section-title">设备权限</span>
          <span class="section-desc">勾选用户可以操控的设备</span>
        </div>
        <el-checkbox-group v-model="selectedDevices">
          <div v-for="(group, category) in deviceGroups" :key="category" class="device-group">
            <div class="device-category">{{ categoryName(category) }}</div>
            <div class="device-list">
              <el-checkbox 
                v-for="device in group" 
                :key="device.id" 
                :label="device.id"
                class="device-checkbox"
              >
                {{ device.deviceName }}
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
        <div v-if="Object.keys(deviceGroups).length === 0" class="no-device">
          暂无设备数据
        </div>
      </div>
      
      <div slot="footer">
        <el-button @click="permissionVisible = false">取消</el-button>
        <el-button type="primary" :loading="permissionLoading" @click="savePermission">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addWxSystemUser,
  deleteWxSystemUser,
  editWxSystemUser,
  getDeviceList,
  getUserDeviceIds,
  getWxSystemUserList,
  resetWxSystemUserPass,
  saveUserDevices
} from "@/api/index";
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: "WxUserManage",
  components: {
    VueQrcode
  },
  data() {
    return {
      height: 500,
      loading: false,
      modalVisible: false,
      modalVisibleWeiXin: false,
      modalTitle: "",
      submitLoading: false,
      selectItem: {},
      qrcodeText: "",
      searchForm: {
        username: "",
        realName: ""
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      data: [],
      form: {
        id: "",
        username: "",
        password: "",
        realName: "",
        mobile: "",
        status: 1,
        remark: ""
      },
      formValidate: {
        username: [{ required: true, message: "登录账号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "登录密码不能为空", trigger: "blur" }],
        realName: [{ required: true, message: "真实姓名不能为空", trigger: "blur" }]
      },
      // 权限配置相关
      permissionVisible: false,
      permissionLoading: false,
      selectedMenus: [],
      selectedDevices: [],
      deviceList: [],
      deviceGroups: {}
    };
  },
  mounted() {
    this.height = document.documentElement.clientHeight;
    this.getDataList();
  },
  methods: {
    bindWeiXin(row) {
      this.selectItem = row;
      // 生成二维码链接，userType=system 表示系统用户
      this.qrcodeText = "https://djhwx.iceoncake.com/h5/pages/bind/weixinBind?id=" + row.id + "&userType=system";
      this.modalVisibleWeiXin = true;
    },
    getDataList() {
      this.loading = true;
      getWxSystemUserList({
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm
      }).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.page.total = res.result.total;
        }
      });
    },
    changePage(v) {
      this.page.currentPage = v;
      this.getDataList();
    },
    changePageSize(v) {
      this.page.pageSize = v;
      this.getDataList();
    },
    add() {
      this.modalTitle = "添加用户";
      this.form = {
        id: "",
        username: "",
        password: "",
        realName: "",
        mobile: "",
        status: 1,
        remark: ""
      };
      this.modalVisible = true;
      this.$nextTick(() => {
          this.$refs.form.clearValidate();
      });
    },
    edit(row) {
      this.modalTitle = "编辑用户";
      this.form = {
        id: row.id,
        username: row.username,
        password: "", // 编辑时不显示密码
        realName: row.realName,
        mobile: row.mobile,
        status: row.status,
        remark: row.remark
      };
      this.modalVisible = true;
      this.$nextTick(() => {
          this.$refs.form.clearValidate();
      });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.form.id) {
            editWxSystemUser(this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$message.success("操作成功");
                this.modalVisible = false;
                this.getDataList();
              }
            });
          } else {
            addWxSystemUser(this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$message.success("操作成功");
                this.modalVisible = false;
                this.getDataList();
              }
            });
          }
        }
      });
    },
    remove(row) {
      this.$confirm("确认删除该用户?", "提示", {
        type: "warning"
      }).then(() => {
        deleteWxSystemUser({ ids: row.id }).then(res => {
          if (res.success) {
            this.$message.success("删除成功");
            this.getDataList();
          }
        });
      });
    },
    handleResetPass(row) {
      this.$confirm("确认重置密码为 123456 ?", "提示", {
        type: "warning"
      }).then(() => {
        resetWxSystemUserPass({ ids: row.id }).then(res => {
          if (res.success) {
            this.$message.success("重置成功");
          }
        });
      });
    },
    handleStatusChange(row) {
        editWxSystemUser({id: row.id, status: row.status}).then(res => {
            if(res.success) {
                this.$message.success("状态更新成功");
            } else {
                row.status = row.status === 1 ? 0 : 1; // 恢复
            }
        })
    },
    // 获取设备列表
    async loadDeviceList() {
      const res = await getDeviceList({ current: 1, size: 100 });
      if (res.success) {
        this.deviceList = res.result.records || [];
        // 按分类分组
        this.deviceGroups = {};
        this.deviceList.forEach(d => {
          const cat = d.deviceCategory || 'other';
          if (!this.deviceGroups[cat]) {
            this.deviceGroups[cat] = [];
          }
          this.deviceGroups[cat].push(d);
        });
      }
    },
    // 分类名称映射
    categoryName(cat) {
      const map = {
        gate: '道闸设备',
        voice: '喊话设备',
        led: 'LED屏',
        other: '其他设备'
      };
      return map[cat] || cat;
    },
    // 打开权限配置弹窗
    async openPermission(row) {
      this.selectItem = row;
      
      // 解析菜单权限
      this.selectedMenus = row.permissions ? row.permissions.split(',').filter(p => p) : [];
      
      // 加载设备列表
      await this.loadDeviceList();
      
      // 获取用户设备权限
      const res = await getUserDeviceIds(row.id);
      if (res.success) {
        this.selectedDevices = res.result || [];
      } else {
        this.selectedDevices = [];
      }
      
      this.permissionVisible = true;
    },
    // 保存权限配置
    async savePermission() {
      this.permissionLoading = true;
      try {
        // 保存菜单权限
        const menuPermissions = this.selectedMenus.join(',');
        await editWxSystemUser({
          id: this.selectItem.id,
          permissions: menuPermissions
        });
        
        // 保存设备权限
        await saveUserDevices({
          userId: this.selectItem.id,
          deviceIds: this.selectedDevices
        });
        
        this.$message.success("权限配置保存成功");
        this.permissionVisible = false;
        this.getDataList(); // 刷新列表
      } catch (e) {
        this.$message.error("保存失败");
      } finally {
        this.permissionLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.search {
  .cTitle {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    line-height: 32px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.page {
  margin-top: 15px;
}

.vxe-pager.is--perfect .vxe-pager--num-btn:not(.is--disabled).is--active {
  background-color: #b6986d;
}

.is--checked.vxe-checkbox,
.is--checked.vxe-checkbox .vxe-checkbox--icon,
.is--checked.vxe-custom--option,
.is--checked.vxe-custom--option .vxe-checkbox--icon,
.is--checked.vxe-export--panel-column-option,
.is--checked.vxe-export--panel-column-option .vxe-checkbox--icon,
.is--checked.vxe-table--filter-option,
.is--checked.vxe-table--filter-option .vxe-checkbox--icon,
.is--indeterminate.vxe-checkbox,
.is--indeterminate.vxe-checkbox .vxe-checkbox--icon,
.is--indeterminate.vxe-custom--option,
.is--indeterminate.vxe-custom--option .vxe-checkbox--icon,
.is--indeterminate.vxe-export--panel-column-option,
.is--indeterminate.vxe-export--panel-column-option .vxe-checkbox--icon,
.is--indeterminate.vxe-table--filter-option,
.is--indeterminate.vxe-table--filter-option .vxe-checkbox--icon {
  color: #b6986d;
}

// 权限配置弹窗样式
.permission-section {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  
  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    .section-title {
      font-size: 15px;
      font-weight: bold;
      color: #333;
      margin-right: 12px;
      &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 14px;
        background: #409EFF;
        margin-right: 8px;
        vertical-align: middle;
        border-radius: 2px;
      }
    }
    
    .section-desc {
      font-size: 12px;
      color: #909399;
    }
  }
  
  .menu-checkbox-group {
    padding-left: 12px;
    /deep/ .el-checkbox {
      margin-right: 24px;
      margin-bottom: 8px;
    }
  }
  
  .device-group {
    margin-bottom: 12px;
    padding-left: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .device-category {
      font-size: 13px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 8px;
      padding-left: 8px;
      border-left: 2px solid #ddd;
    }
    
    .device-list {
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;
      
      .device-checkbox {
        margin-right: 20px;
        margin-bottom: 6px;
      }
    }
  }
  
  .no-device {
    color: #909399;
    text-align: center;
    padding: 20px;
    font-size: 13px;
  }
}
</style>

